import storage from '~/helpers/_core/storage';

function saveImpersonateData({ payload, store }) {
  if (store.state._core.application.independentTabsEnabled) {
    return storage.session.impersonate = JSON.stringify(payload);
  }
  storage.local.impersonate = JSON.stringify(payload);
}

function getImpersonateData({ store }) {
  if (store.state._core.application.independentTabsEnabled) {
    return JSON.parse(storage.session.impersonate);
  }
  return JSON.parse(storage.local.impersonate);
}

function removeImpersonateData({ store }) {
  if (store.state._core.application.independentTabsEnabled) {
    return storage.session.impersonate = null;
  }
  storage.local.impersonate = null;
}

export {
  getImpersonateData,
  removeImpersonateData, saveImpersonateData
};

